import axios from "axios";
import { th } from "date-fns/locale";
import Cookies from "js-cookie";

const baseUrl = `${process.env.REACT_APP_BASE_URL}/Admin`;

const getCookie = (name) => {
  const cookieArr = document.cookie.split(";");
  for (let cookie of cookieArr) {
    const [key, value] = cookie.split("=");
    if (key.trim() === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
};
const token = getCookie("token");

export const adminLogin = async (email, password) => {
  try {
    const response = await axios.post(`${baseUrl}/adminLogin`, {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.error("Error logging in admin :", error);
    throw error;
  }
};

export const getAllBanks = async () => {
  const token = getCookie("token");

  try {
    const response = await axios.get(`${baseUrl}/getAllBanks`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting all banks : ", error);
    throw error;
  }
};

export const createExchangeRate = async (
  body,
  source,
  hashtag,
  userMessage
) => {
  const token = getCookie("token");
  try {
    const response = await axios.post(
      `${baseUrl}/createExchangeRate`,
      {
        body,
        source,
        hashtag: "#ExchangeRates",
        message: userMessage,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating rate:  ", error);
    throw error;
  }
};

export const fetchAllExchangeRate = async () => {
  const token = getCookie("token");
  try {
    const response = await axios.get(
      `${baseUrl}/getAllExchangeRates`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching rate: ", error);
    throw error;
  }
};

export const exchangeRateMessageUpdate = async (exchangeId, customMessage) => {
  const token = getCookie("token");
  try {
    const response = await axios.post(
      `${baseUrl}/editExchangeRateByIdAfterPost`,
      {
        exchangeId: exchangeId,

        customMessage: customMessage,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching rate: ", error);
    throw error;
  }
};

// export const fetchExchangeRateByDate = async () => {
//   try {
//     const response  = await axios.get(``)
//   } catch (error) {
//     console.error("Error fetcing ExchangeRateByDate : ", error)
//     throw error
//   }
// }

export const updateExchangeRate = async (body, source, hashtag, id) => {
  try {
    const response = await axios.put(
      `${baseUrl}/updateExchangeRate`,
      {
        exchangeId: id,
        body,
        source,
        hashtag: "#ExchangeRates",
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating the exchnge rate: ", error);
  }
};

export const viewCount = async (postId) => {
  try {
    const response = await axios.post(`${baseUrl}/incrementViewCount`, {
      postId,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating view count : ", error);
    throw error;
  }
};

export const addAdmin = async (name, email, password, type) => {
  const token = getCookie("token");
  try {
    const response = await axios.post(
      `${baseUrl}/registerAdmin`,
      {
        name,
        email,
        password,
        type,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding admin : ", error);
    throw error;
  }
};

export const userActivation = async (
  userId,
  contact_information,
  chat_id,
  is_active
) => {
  const token = getCookie("token");

  try {
    const response = await axios.post(
      `${baseUrl}/userActivation`,
      {
        userId,
        contact_information,
        chat_id,
        is_active,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error in activation: ", error);
    throw error;
  }
};

export const removeAdmin = async (removeid) => {
  try {
    const token = getCookie("token");

    const response = await axios.post(
      `${baseUrl}/removeAdmin`,
      {
        removeid,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error removing admin : ", error);
    throw error;
  }
};

export const getAdmins = async () => {
  try {
    const token = getCookie("token");

    const response = await axios.get(`${baseUrl}/fetchadmins`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting all admins : ", error);
    throw error;
  }
};

export const getLanguage = async () => {
  try {
    const response = await axios.get(`${baseUrl}/getLanguages`);
    return response.data;
  } catch (error) {
    console.error("error getting language", error);
    throw error;
  }
};

export const createGeneralInquiry = async (
  user_name,
  phone_number,
  description,
  posted_from,
  poster,
  topic_id,
  chat_id
) => {
  try {
    const response = await axios.post(`${baseUrl}/createGeneralInquiry`, {
      user_name,
      phone_number,
      description,
      posted_from,
      poster,
      topic_id,
      chat_id,
    });
    return response.data;
  } catch (error) {
    console.error("Error createing inquiry", error);
    throw error;
  }
};
